/* globals window navigator */

const Emoji = new RegExp(
  '(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])',
  'gm',
);

const ReplaceEmoji = (temp_string) => {
  let output = temp_string;

  if (window && navigator) {
    const isMacChrome =
      !!window.chrome && !!(navigator.platform.indexOf('Mac') > -1);

    if (output !== null && isMacChrome === true) {
      const matches = [...output.matchAll(Emoji)];

      if (matches.length) {
        matches.forEach((element) => {
          output = output.replace(element[0], `${element[0]}\u00A0`);
        });
      }
    }
  }

  return output;
};

export default ReplaceEmoji;
